import { API } from "@/lib/api";

export const track = (event, properties = {}) => {
  try { window.posthog?.capture?.(event, properties); } catch { /* analytics never blocks the page */ }
};

export const openAcademyInquiry = (preset = {}) => {
  track("academy_inquiry_opened", { offer: preset.offer || "none", source: preset.source || "unknown" });
  window.dispatchEvent(new CustomEvent("dcyb:academy-inquiry", { detail: preset }));
};

export const prefersReducedMotion = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const goToSection = (id) => {
  const target = document.getElementById(id);
  if (!target) return;
  target.scrollIntoView({ block: "start", behavior: prefersReducedMotion() ? "auto" : "smooth" });
  target.querySelector("[data-academy-focus]")?.focus({ preventScroll: true });
};

export const academyRequest = async (path, options = {}) => {
  const response = await fetch(`${API}/academy${path}`, { credentials: "include", headers: { "Content-Type": "application/json" }, ...options });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const detail = Array.isArray(body.detail) ? body.detail[0]?.msg?.replace(/^Value error, /, "") : body.detail;
    const error = new Error(detail || "Something went wrong. Please try again.");
    error.status = response.status;
    throw error;
  }
  return body;
};
